'use strict';

module.exports = function when(value, fn, defaultFn) {
  if (value) {
    fn(this);
  } else {
    defaultFn(this);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/when.js
// module id = 1288
// module chunks = 2